const parseCanvassingSessionTimestamp = (timestamp: unknown): Date | null => {
  const date = new Date(String(timestamp));
  return Number.isNaN(date.valueOf()) ? null : date;
};

export const formatCanvassingSessionTimestamp = (timestamp: unknown): string => {
  const date = parseCanvassingSessionTimestamp(timestamp);
  if (date === null) return '–';

  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const getCanvassingSessionTimestampPresentation = (
  timestamp: unknown,
): { dateTime: string; display: string; accessible: string } | null => {
  const date = parseCanvassingSessionTimestamp(timestamp);
  if (date === null) return null;

  return {
    dateTime: date.toISOString(),
    display: formatCanvassingSessionTimestamp(date),
    accessible: date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      timeZoneName: 'long',
    }),
  };
};

export const formatCanvassingSessionDuration = (totalSeconds: number): string => {
  const clampedSeconds = Math.max(0, totalSeconds);
  const minutes = Math.floor(clampedSeconds / 60);
  const seconds = Math.round(clampedSeconds % 60);
  return `${minutes}m ${seconds}s`;
};

export const formatCanvassingSessionMilliseconds = (totalMilliseconds: number): string =>
  formatCanvassingSessionDuration(totalMilliseconds / 1_000);

export const formatReceivedAndExpected = (received: number, expected: number | null | undefined): string =>
  `${received} / ${expected ?? '–'}`;
